import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './components/Home';
import FullGallery from './components/FullGallery';
import ContactFab from './components/ContactFab';

function App() {
  return (
    <div className="min-h-screen bg-wedding-ivory selection:bg-wedding-gold selection:text-white">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/gallery" element={<FullGallery />} />
      </Routes>
      <ContactFab />

    </div>
  );
}

export default App;
